<template>
    <div class="wb-overlay-color-picker" :style="{'left': left + 'px', 'top': top + 'px'}" v-on:click.stop>
        <select class="wb-overlay-color-picker-select"
                v-on:change="configurationStore.setColorCategory(type, $event.target.value)"
                :value="selectedCategory">
            <option class="wb-overlay-color-picker-select-option"
                    v-for="category in categories"
                    :key="category.id"
                    :value="category.id">
                {{category.name}}
            </option>
        </select>
        <SidebarCategoriesScroll :direction="'up'"
                                 :width="'312px'"
                                 v-show="showTopScroll"
                                 v-on:click="scrollByClick(-1)" style="position: absolute; top: 64px"/>
        <div class="wb-overlay-color-picker-options"
             ref="colorContainer"
             v-on:scroll="scrollComputeHandler()">
            <div class="wb-overlay-color-picker-option"
                 v-for="option in options"
                 :class="{'wb-overlay-color-picker-option-active': option.id === selectedColor}"
                 :key="option.id"
                 v-on:click="configurationStore.setColor(type, option.id)">
                <div class="wb-overlay-color-picker-option-img"
                     :style="{'background': 'url(' + getImageHandler(option.priview) + ')'}"
                     :title="option.name">
                </div>
            </div>
        </div>
        <SidebarCategoriesScroll :direction="'down'"
                                 :width="'312px'"
                                 v-show="showBotScroll"
                                 v-on:click="scrollByClick(1)"/>
    </div>
</template>

<script>
import SidebarCategoriesScroll from '@/UI/Components/ComponentsSidebarCategories/SidebarCategoriesScroll.vue';
import { useStoreData } from '@/Store/storeData';
import { getImageHandler } from '@/lib/getImage';
import { useConfigurationStore } from '@/Store/storeConfiguration';

export default {
    name: 'OverlayColorPicker',
    components: { SidebarCategoriesScroll },
    setup() {
        const storeData = useStoreData();
        const configurationStore = useConfigurationStore();
        return {
            storeData,
            configurationStore,
        };
    },
    data() {
        return {
            scrollHeight: 0,
            scrollTop: 0,
            containerHeight: 0,
            scrollStep: 96,
        };
    },
    props: [
        'type',
        'categoriesProp',
        'selectedCategory',
        'selectedColor',
        'optionsProp',
        'top',
        'left',
    ],
    computed: {
        showTopScroll() {
            return this.scrollTop > 0;
        },
        showBotScroll() {
            return this.scrollHeight > this.containerHeight + this.scrollTop;
        },
        categories() {
            if (this.categoriesProp) {
                return this.categoriesProp;
            }
            return [];
        },
        options() {
            if (this.optionsProp) {
                return this.optionsProp;
            }
            return [];
        },
    },
    methods: {
        getImageHandler,
        scrollComputeHandler() {
            this.scrollHeight = this.getScrollHeight();
            this.scrollTop = this.getScrollTop();
            this.containerHeight = this.getContainerHeight();
        },
        getScrollHeight() {
            return this.$refs.colorContainer?.scrollHeight;
        },
        getScrollTop() {
            return this.$refs.colorContainer?.scrollTop;
        },
        getContainerHeight() {
            return this.$refs.colorContainer?.clientHeight;
        },
        scrollByClick(direction) {
            // TODO add smooth animation
            this.$refs.colorContainer.scrollTop = this.$refs.colorContainer.scrollTop + direction * this.scrollStep;
        },
    },
    mounted() {
        this.scrollComputeHandler();
        window.addEventListener('resize', this.scrollComputeHandler);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.scrollComputeHandler);
    },
};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";
@import "CSS/common.scss";
@import "CSS/fonts.scss";

.wb-overlay-color-picker {
    position: absolute;
    background-color: $white;
    padding: 16px;
    box-sizing: border-box;
    display: grid;
    grid-template-rows: max-content 314px;
    grid-row-gap: 8px;
    width: 312px;
    z-index: 100;
}

.wb-overlay-color-picker-options {
    display: grid;
    //grid-template-columns: auto auto auto;
    grid-template-columns: 88px 88px 88px;
    grid-column-gap: 8px;
    grid-row-gap: 8px;

    overflow-x: hidden;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.wb-overlay-color-picker-options::-webkit-scrollbar {
    display: none;
}

.wb-overlay-color-picker-option {
    width: 88px;
    height: 88px;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid $gray1;
    @include wb-c-flex-center;
    cursor: pointer;
    user-select: none;
}

.wb-overlay-color-picker-option:hover {
    border-color: $green1;
 }

.wb-overlay-color-picker-option-active {
    border-color: $green1 !important;
}

.wb-overlay-color-picker-option-img {
    width: 72px;
    height: 72px;
    border-radius: 36px;
    background-color: $gray1;
    background-position: center;
}

</style>
